import React, { useState, useEffect } from 'react'
import { Button, Box, Link as LinkUI, Input, Stack } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import * as actions from '../../../../redux/actions'
import { useDispatch, useSelector } from 'react-redux'

export default function EditTokenLine({ station, index }) {
  const dispatch = useDispatch()
  const [lineNotifyToken, setLineNotifyToken] = useState(station?.lineToken)

  const handleChange = (role, field, value) => {
    setLineNotifyToken({
      ...lineNotifyToken,
      [role]: {
        ...lineNotifyToken[role],
        [field]: value,
      },
    })
  }

  const onSubmit = async (data, e) => {
    let confirm = window.confirm('อัพเดทข้อมูล')
    //console.log('Add token - ', data, lineNotifyToken)
    const payload = {
      lineToken: lineNotifyToken,
    }
    if (confirm) {
      await dispatch(actions.stationPut(station._id, payload))
      alert('บันทึกสำเร็จ')
      await dispatch(actions.stationAll())
    }
  }

  // console.log('line', lineNotifyToken)

  return (
    <Box padding="4" borderRadius="lg" borderWidth="1px" className="mb-2">
      <div className="grid lg:grid-cols-2 sm:grid-cols-1">
        <div className="flex flex-col w-3/5 m-2 p-1">
          {' '}
          <h3 className="font-bold text-xl font-sans">
            <i className="fas fa-search text-sm"> </i> {station.name}{' '}
          </h3>
          <h5 className="text-base text-gray-700 font-sans">
            {' '}
            {station.description}
          </h5>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="flex items-center">
            <label className="w-32 text-gray-700">พนักงานทั่วไป :</label>
            <div className="flex-1 grid grid-cols-2 gap-4">
              <Input
                type="text"
                value={lineNotifyToken.USER?.tokenAPI}
                onChange={(e) =>
                  handleChange('USER', 'tokenAPI', e.target.value)
                }
                placeholder="ใส่ Token จาก Line Messaging API"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
              <Input
                type="text"
                value={lineNotifyToken.USER?.tokenChat}
                onChange={(e) =>
                  handleChange('USER', 'tokenChat', e.target.value)
                }
                placeholder="ใส่ ID ช่องแชทของ Line"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="flex items-center">
            <label className="w-32 text-gray-700">หัวหน้า :</label>
            <div className="flex-1 grid grid-cols-2 gap-4">
              <Input
                type="text"
                value={lineNotifyToken.ADMIN?.tokenAPI}
                onChange={(e) =>
                  handleChange('ADMIN', 'tokenAPI', e.target.value)
                }
                placeholder="ใส่ Token จาก Line Messaging API"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
              <Input
                type="text"
                value={lineNotifyToken.ADMIN?.tokenChat}
                onChange={(e) =>
                  handleChange('ADMIN', 'tokenChat', e.target.value)
                }
                placeholder="ใส่ ID ช่องแชทของ Line"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="flex items-center">
            <label className="w-32 text-gray-700">ผู้บริหาร :</label>
            <div className="flex-1 grid grid-cols-2 gap-4">
              <Input
                type="text"
                value={lineNotifyToken.MANAGER?.tokenAPI}
                onChange={(e) =>
                  handleChange('MANAGER', 'tokenAPI', e.target.value)
                }
                placeholder="ใส่ Token จาก Line Messaging API"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
              <Input
                type="text"
                value={lineNotifyToken.MANAGER?.tokenChat}
                onChange={(e) =>
                  handleChange('MANAGER', 'tokenChat', e.target.value)
                }
                placeholder="ใส่ ID ช่องแชทของ Line"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="flex items-center">
            <label className="w-32 text-gray-700">ผู้ดูแลระบบ :</label>
            <div className="flex-1 grid grid-cols-2 gap-4">
              <Input
                type="text"
                value={lineNotifyToken.SUPERUSER?.tokenAPI}
                onChange={(e) =>
                  handleChange('SUPERUSER', 'tokenAPI', e.target.value)
                }
                placeholder="ใส่ Token จาก Line Messaging API"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
              <Input
                type="text"
                value={lineNotifyToken.SUPERUSER?.tokenChat}
                onChange={(e) =>
                  handleChange('SUPERUSER', 'tokenChat', e.target.value)
                }
                placeholder="ใส่ ID ช่องแชทของ Line"
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="mt-6">
            <Button
              colorScheme="blue"
              variant="solid"
              size="sm"
              type="submit"
              className="mx-10"
            >
              บันทึก
            </Button>
          </div>
        </form>
      </div>
    </Box>
  )
}
